import React, { useEffect, useState } from 'react';
import { productsAPI } from '../services/api';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

export const ProductsSection = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [activeTab, setActiveTab] = useState('all');

  useEffect(() => {
    const load = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await productsAPI.getAll();
        setProducts(data);
      } catch (e) {
        setError('Erreur lors du chargement des produits');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, []);

  const categories = ['all', 'Batterie', 'Onduleur', 'Kit'];
  const categoryLabels = {
    'all': 'Tous',
    'Batterie': 'Batteries',
    'Onduleur': 'Onduleurs',
    'Kit': 'Kits'
  };

  const filteredProducts = products.filter(p => activeTab === 'all' ? true : p.category === activeTab);

  if (loading) return <section className="py-16"><div className="container mx-auto px-4">Chargement...</div></section>;
  if (error) return <section className="py-16"><div className="container mx-auto px-4 text-red-600">{error}</div></section>;

  return (
    <section id="products" className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex gap-3 mb-6">
          {categories.map(cat => (
            <button key={cat} className={`px-4 py-2 rounded ${activeTab === cat ? 'bg-yellow-600 text-black' : 'bg-gray-100'}`} onClick={() => setActiveTab(cat)}>
              {categoryLabels[cat]}
            </button>
          ))}
        </div>

        {filteredProducts.length === 0 ? (
          <div className="text-gray-600">Aucun produit.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {filteredProducts.map(product => (
              <div key={product.id} className="group bg-white border shadow-sm rounded-xl overflow-hidden hover:shadow-lg transition">
                <div className="p-4">
                  <img 
                    src={product.image_base64 || ((product.images_base64 && product.images_base64[0]) ? product.images_base64[0] : (product.images && product.images[0]) ? product.images[0] : product.image)}
                    alt={product.name}
                    className="w-full h-48 object-contain bg-white group-hover:scale-105 transition-transform duration-300"
                    style={{maxWidth: '1200px', margin: '0 auto'}}
                  />
                </div>
                <div className="px-4 pb-4">
                  <h3 className="font-semibold text-gray-900 mb-1">{product.name}</h3>
                  <div className="text-sm text-gray-700 mb-2">{product.price}</div>
                  <div className="flex gap-2">
                    <Button onClick={() => document.querySelector('#contact')?.scrollIntoView({behavior:'smooth'})} className="bg-yellow-600 text-black">Demander un devis</Button>
                    <Link to={`/product/${product.id}`} className="inline-flex items-center px-4 py-2 border rounded hover:bg-gray-50">Voir détails</Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};